import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class ClientsService extends BasicService {
    getClients() {
        return this.checkError(axios.get(this.getApiUrl(true) + 'clients/getClients', { headers: authHeader() }));
    }

    deleteClient(dbid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'clients/deleteClient', { dbid: dbid }, { headers: authHeader() }));
    }
    
    deleteAll() {
        return this.checkError(axios.post(this.getApiUrl(true) + 'clients/deleteAll', {}, { headers: authHeader() }));
    }
    
    deleteBotAccessGroup(dbid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'clients/deleteBotAccessGroup', { dbid: dbid }, { headers: authHeader() }));
    }
    
    addBotAccessGroup(dbid) {
        return this.checkError(axios.post(this.getApiUrl(true) + 'clients/addBotAccessGroup', { dbid: dbid }, { headers: authHeader() }));
    }
}

export default new ClientsService();